import { API_BASE } from '../constants';
import { getData } from '../_base';
import { getCurrentLanguageDto } from '../../utilitys/language';
import { ManualDto } from '../../dto/admin/types';

const base = `${API_BASE}/v1/Manuals`;

const url = {
  getByLanguage: `${base}/Manuals`,
};

export const getManaulsByLangApi = async (): Promise<ManualDto[]> => {
  const lngDto = getCurrentLanguageDto();
  const _url = `${url.getByLanguage}/${lngDto.id}`;
  const result = await getData<ManualDto[]>(_url);
  if (result && !result.hasError && result.data ) return result.data;
  else return [];
};
